export default {
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Ideo Core",
    "Language": "de-DE",
    "Messages": {
        "Administracja": "Administration",
        "Akceptuj": "Akzeptieren",
        "Aktywne kanały komunikacji": "Aktive Kommunikationskanäle",
        "Anuluj": "Abbrechen",
        "Błąd w kodzie MJML.": "Fehler im MJML-Code.",
        "Centrum powiadomień": "Benachrichtigungszentrum",
        "Data utworzenia": "Erstellungsdatum",
        "Data wysłania": "Versanddatum",
        "Dodaj szablon": "Vorlage hinzufügen",
        "Dodaj typ": "Typ hinzufügen",
        "Dodaj wiadomość": "Nachricht hinzufügen",
        "Dodaj zmienną": "Variable hinzufügen",
        "Dodaj zmienne dla szablonu": "Variablen zur Vorlage hinzufügen",
        "Dodane przez": "Hinzugefügt von",
        "Dodawanie komunikatu": "Nachricht hinzufügen",
        "Dodawanie szablonu powiadomień": "Benachrichtigungsvorlage hinzufügen",
        "Dodawanie typu powiadomienia": "Benachrichtigungstyp hinzufügen",
        "Edycja komunikatu": "Nachricht bearbeiten",
        "Edycja szablonu powiadomień": "Benachrichtigungsvorlage bearbeiten",
        "Edycja typu powiadomienia": "Benachrichtigungstyp bearbeiten",
        "Edytowane mogą być tylko szablony włączonych i obsługiwanych kanałów.": "Es können nur Vorlagen für aktivierte und unterstützte Kanäle bearbeitet werden.",
        "Edytuj": "Bearbeiten",
        "Edytuj szablon": "Vorlage bearbeiten",
        "Edytuj typ": "Typ bearbeiten",
        "Edytuj wiadomość": "Nachricht bearbeiten",
        "ID": "ID",
        "Kanał jest domyślnie wymagany. Nie da się wyłączyć wysyłania powiadomienia tym kanałem. Możliwa jest tylko zmiana tytułu i treści komunikatu.": "Der Kanal ist standardmäßig erforderlich. Der Versand von Benachrichtigungen über diesen Kanal kann nicht deaktiviert werden. Es können nur der Titel und der Inhalt der Nachricht geändert werden.",
        "kanał wymagany": "Kanal erforderlich",
        "Kanały": "Kanäle",
        "Kanały komunikacji": "Kommunikationskanäle",
        "Kanały obsługiwane przez wybrany typ powiadmienia": "Vom ausgewählten Benachrichtigungstyp unterstützte Kanäle",
        "Kanały włączone w ustawieniach aplikacji": "In den Anwendungseinstellungen aktivierte Kanäle",
        "Kategoria": "Kategorie",
        "Klucze": "Schlüssel",
        "Kod MJML": "MJML-Code",
        "Konfiguracja domyślna": "Standardeinstellung",
        "Konfiguracja stopki oraz logo wiadomości mailowych.": "Konfiguration der Fußzeile und des Logos von E-Mail-Nachrichten.",
        "Kopiuj": "Kopieren",
        "Lista jest pusta": "Die Liste ist leer",
        "Logo": "Logo",
        "Logo jest wspólne dla wszystkich wersji językowych.": "Das Logo wird für alle Sprachversionen verwendet.",
        "Moje dokumenty": "Meine Dokumente",
        "Nazwa": "Name",
        "Nazwa powiadomienia": "Name der Benachrichtigung",
        "Nazwa szablonu": "Vorlagenname",
        "Nazwa typu": "Typname",
        "Nazwa zmiennej": "Variablenname",
        "Nazwa zmiennej nie może być pusta.": "Der Variablenname darf nicht leer sein.",
        "Nie udało się pobrać listy kanałów": "Die Kanalliste konnte nicht abgerufen werden",
        "Nie udało się pobrać listy powiadomień": "Die Benachrichtigungsliste konnte nicht abgerufen werden",
        "Nie udało się pobrać powiadomień.": "Die Benachrichtigungen konnten nicht abgerufen werden.",
        "Nie udało się wykonać akcji": "Die Aktion konnte nicht ausgeführt werden",
        "Nie znaleziono żadnych wyników.": "Keine Ergebnisse gefunden.",
        "Odznacz wszystkie": "Alle abwählen",
        "Poczta wychodząca": "Ausgehende Post",
        "Podgląd HTML": "HTML-Vorschau",
        "Podgląd szablonu": "Vorlagenvorschau",
        "Pokaż w koncie użytkownika": "Im Benutzerkonto anzeigen",
        "Potwierdź akceptację": "Freigabe bestätigen",
        "Potwierdzenie usunięcia": "Löschbestätigung",
        "Powiadomienia": "Benachrichtigungen",
        "Powiadomienia mailowe": "E-Mail-Benachrichtigungen",
        "Powiadomienia zostały skonfigurowane.": "Die Benachrichtigungen wurden konfiguriert.",
        "Powiadomienie jest domyślnie wymagane. Nie da się wyłączyć wysyłania tego powiadomienia.": "Die Benachrichtigung ist standardmäßig erforderlich. Der Versand dieser Benachrichtigung kann nicht deaktiviert werden.",
        "Powiadomienie testowe zostało wysłane.": "Die Testbenachrichtigung wurde gesendet.",
        "Powiadomienie zbiorowe zostało dodane.": "Die Sammelbenachrichtigung wurde hinzugefügt.",
        "Powiadomienie zbiorowe zostało zaktualizowane.": "Die Sammelbenachrichtigung wurde aktualisiert.",
        "Powiększ kod MJML": "MJML-Code vergrößern",
        "Powiększ podgląd": "Vorschau vergrößern",
        "Powrót": "Zurück",
        "Stan powiadomienia": "Benachrichtigungsstatus",
        "Status dokumentu został zmieniony.": "Der Dokumentstatus wurde geändert.",
        "Status powiadomienia": "Benachrichtigungsstatus",
        "Stopka": "Fußzeile",
        "Stopkę ustawiasz osobno dla każdej wersji językowej.": "Die Fußzeile wird für jede Sprachversion separat festgelegt.",
        "Strona główna": "Startseite",
        "System": "System",
        "System powiadomień": "Benachrichtigungssystem",
        "Szablon został dodany.": "Die Vorlage wurde hinzugefügt.",
        "Szablon został usunięty.": "Die Vorlage wurde gelöscht.",
        "Szablon został zaktualizowany.": "Die Vorlage wurde aktualisiert.",
        "Szablony email": "E-Mail-Vorlagen",
        "Ten kanał ma możliwość wysyłania tekstu sformatowanego.": "Dieser Kanal unterstützt den Versand von formatiertem Text.",
        "Ten kanał nie ma możliwości wysyłania tekstu sformatowanego.": "Dieser Kanal unterstützt den Versand von formatiertem Text nicht.",
        "Testuj": "Testen",
        "Treść": "Inhalt",
        "Typ powiadomienia": "Benachrichtigungstyp",
        "Typy powiadomień": "Benachrichtigungstypen",
        "Tytuł": "Titel",
        "Tytuł powiadomienia": "Titel der Benachrichtigung",
        "Ustawienia": "Einstellungen",
        "Ustawienia powiadomień zostały zaktualizowane.": "Die Benachrichtigungseinstellungen wurden aktualisiert.",
        "Usuń": "Löschen",
        "Wczytywanie danych…": "Daten werden geladen…",
        "Wersje": "Versionen",
        "Włącznik wysyłki wszystkich powiadomień.": "Schalter zum Aktivieren oder Deaktivieren des Versands aller Benachrichtigungen.",
        "Włączone": "Aktiviert",
        "Włączony": "Aktiviert",
        "Wpis do kalendarza został usunięty.": "Der Kalendereintrag wurde gelöscht.",
        "Wszystko": "Alles",
        "wybierz": "Auswählen",
        "Wybierz typ powiadomienia aby zobaczyć dostępne klucze.": "Wählen Sie einen Benachrichtigungstyp aus, um die verfügbaren Schlüssel anzuzeigen.",
        "wybierz...": "Auswählen...",
        "Wybór języka": "Sprachauswahl",
        "Wyłączony": "Deaktiviert",
        "Wymagane": "Erforderlich",
        "Wymagane kanały pozostają zawsze aktywne.": "Erforderliche Kanäle bleiben immer aktiv.",
        "Wyślij do": "Senden an",
        "Wystąpiły błędy w formularzu. Sprawdź wszystkie pola formularza.": "Im Formular sind Fehler aufgetreten. Überprüfen Sie alle Formularfelder.",
        "Wysyłaj tym kanałem": "Über diesen Kanal senden",
        "Wysyłka wiadomości": "Nachrichtenversand",
        "Żaden kanał komunikacji nie został włączony w ustawieniach powiadomień.": "In den Benachrichtigungseinstellungen wurde kein Kommunikationskanal aktiviert.",
        "Zapisz": "Speichern",
        "Zapisz i wróć": "Speichern und zurück",
        "Zapisz ustawienia": "Einstellungen speichern",
        "Zaznacz wszystkie": "Alle auswählen",
        "Zmiana hasła": "Passwort ändern",
        "Zmienne": "Variablen"
    }
};
